import styled from "styled-components";

export const Title = styled.span<{ $color?: string }>`
  color: ${(props) => props.$color ?? props.theme.color.tertiary};
  font-size: ${(props) => props.theme.font.size.title.medium};
  font-family: ${(props) => props.theme.font.family.title};
  text-align: center;
  z-index: 1;
`;

export const BigTitle = styled.span<{ $fontSize?: string; $color?: string; $textAlign?: string }>`
  color: ${(props) => props.$color ?? props.theme.color.primary};
  font-size: ${(props) => props.$fontSize ?? props.theme.font.size.title.xxbig};
  font-family: ${(props) => props.theme.font.family.title};
  text-shadow: ${(props) => props.theme.font.elevation.hard.big};
  text-align: ${(props) => props.$textAlign};
  font-weight: normal;
`;

export const Paragraph = styled.span<{ $color?: string }>`
  color: ${(props) => props.$color ?? props.theme.color.primaryDark};
  font-size: ${(props) => props.theme.font.size.title.small};
  font-family: ${(props) => props.theme.font.family.main};
  text-align: center;
`;
